import { APICONSTANTS } from '../../constants/api-constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericCrudService } from '../basic/generic.crud.service';
import { TvaModel } from '../../models/simple-types/tva.model';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HostnameService } from '../basic/hostname.service';
import { GenericLibelleService } from '../basic/generic-libelle.service';

@Injectable()
export class TvaService extends GenericLibelleService<TvaModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTETVA, hostnameService);
  }

  getTvaFromCode(code: string): Observable<TvaModel> {
    // tslint:disable-next-line
    return this.http.get<TvaModel>(APICONSTANTS.URLAPI.value + this.route + 'GetFromCode/' + code).pipe(catchError( err => this.requestCatchError(err, 'Le chargement')));
  }

}
